import React from 'react';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import SharedConstraintFields from './shared-fields';
import NumericField from '../../numeric-field';

type StockLoanAvailabilityProps = {
  params: types.optimizer.StockLoanAvailabilityDraft;
  setParams: (_params: types.optimizer.StockLoanAvailabilityDraft) => void;
  readOnly: boolean;
  validationDef: types.common.ValidationErrors;
};

const StockLoanAvailability = ({ params, setParams, readOnly, validationDef }: StockLoanAvailabilityProps) => {
  const [showMore, setShowMore] = React.useState(false);
  return (
    <mui.core.Box p={2}>
      <mui.core.Grid container spacing={4}>
        <mui.core.Grid size={{ xs: 12, md: 4 }}>
          <NumericField
            textFieldProps={{
              label: 'Default Availability',
              fullWidth: true,
              variant: 'outlined',
              size: 'small',
              required: true,
            }}
            disabled={readOnly}
            value={params.default_available_shares}
            setValue={(v) => setParams({ ...params, default_available_shares: v })}
          />
        </mui.core.Grid>

        <mui.core.Grid size={{ xs: 12, md: 12 }} >
          {showMore && (
            <SharedConstraintFields
              params={params}
              setParams={setParams}
              showRelaxation={false}
              readOnly={readOnly}
              validationDef={validationDef}
            />
          )}
          <mui.core.Button
            onClick={() => {
              setShowMore(!showMore);
            }}
            color="primary"
            sx={{ mx: 2, mb: 2 }}
            startIcon={showMore ? <mui.icons.Remove /> : <mui.icons.Add />}
          >
            {showMore ? <>Show Less</> : <>Show More</>}
          </mui.core.Button>
        </mui.core.Grid>
      </mui.core.Grid>
    </mui.core.Box>
  );
};

export default StockLoanAvailability;
